import { TENDER_STATUSES } from '@/constants/tenderStatuses'

export default (status) => {
  const colors = {
    [TENDER_STATUSES.DRAFT]: '#0000FF',
    [TENDER_STATUSES.ACTIVE_TENDERING]: '#006400',
    [TENDER_STATUSES.ACTIVE_QUALIFICATION]: '#55DD33',
    [TENDER_STATUSES.ACTIVE_AWARDED]: '#FFA500',
    [TENDER_STATUSES.COMPLETE]: '#808080',
    [TENDER_STATUSES.CANCELED]: '#FF0000',
  };
  if (colors[status]) {
    return colors[status];
  } else {
    return 'inherit';
  }
}
